export default __webpack_public_path__ + "static/media/closeWhite.4429f032.svg";